import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import logger from '@/shared/utils/logger'
import ErrorBoundary from '@/shared/ui/error-boundary'
import { initSentry } from '@/config/sentry'
import { getPostHogProviderOptions, isPostHogEnabled } from '@/config/posthog'
import { environment } from '@/config/environment'
import { PostHogProvider } from '@posthog/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { runAdscoreOnPageLoad } from '@/shared/security'

// Initialize i18n (must be imported before App)
import './lib/i18n'

initSentry()
runAdscoreOnPageLoad()

declare global {
  var logger: {
    debug: (...args: any[]) => void;
    info: (...args: any[]) => void;
    warn: (...args: any[]) => void;
    error: (...args: any[]) => void;
    log: (...args: any[]) => void;
  };
}

globalThis.logger = logger;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

const AppTree = (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </ErrorBoundary>
);

createRoot(document.getElementById('root')!).render(
  isPostHogEnabled() ? (
    <PostHogProvider apiKey={environment.POSTHOG_KEY} options={getPostHogProviderOptions()}>
      {AppTree}
    </PostHogProvider>
  ) : (
    AppTree
  )
)
